import React, {Component} from 'react'
import firebase from '../Configs/firebase'

class PlanDetailsSave extends Component{
    constructor(props){
        super(props)
        this.state = {
            planId:null,
            name:null,
            description:null,
            address:null,
            deed:'',
            shapeId:[]
        }

        this.handleChange = this.handleChange.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
        this.saveToFirebase = this.saveToFirebase.bind(this)
        this.updateToFirebase = this.updateToFirebase.bind(this)
    }

    componentDidMount(){
        const { currentPlan } = this.props
        this.setState({
            name:currentPlan.name,
            description:currentPlan._description,
            address:currentPlan.address,
            deed:currentPlan.deed
        })
    }

    handleClose(){
        const {setShowMenu, setSaved} = this.props
        setShowMenu(false)
        setSaved(false)
    }

    handleChange(event) {
        const {name, value} = event.target;
        this.setState(() => ({
            [name]: value
        }))
    }

    handleSubmit(event){
        event.preventDefault()
        const { currentPlan, setIsOpenSavingModal } = this.props
        if( currentPlan.shapesArray.length > 0 || currentPlan.markerCoord !== null ){
            setIsOpenSavingModal(true)
            if(currentPlan.uid === ''){
                this.saveToFirebase()
            }else {
                this.updateToFirebase()
            }
        }
        else{
            alert('คุณยังไม่ได้ทำการสร้างแปลง')
        }
       
    }

    saveToFirebase(){
        const { name, description, address, deed } = this.state
        const { getPlan, setSaved, currentDroneLayer, setCurrentDroneLayer, setEdited, currentPlan } = this.props
        var droneIdArray = []
        var layerSetting = []
        if( currentDroneLayer !== null ){
            droneIdArray.push(currentDroneLayer.uid) 
            layerSetting.push({is_hidden:false})
        }
        var midpoint = null
        if( currentPlan.markerCoord !== null && currentPlan.markerCoord !== undefined && currentPlan.markerCoord !== '' ){
            midpoint = new firebase.firestore.GeoPoint(currentPlan.markerCoord.lat,currentPlan.markerCoord.lng)
        }
        firebase.firestore().collection('plans').add({
            address:address,
            deed:deed,
            description:description,
            name:name,
            midpoint:midpoint,
            layers:droneIdArray,
            layers_settings:layerSetting,
            uid:firebase.auth().currentUser.uid,
            created_date:new Date(),
            updated_date:new Date()
        })
        .then(res=>{
            var promise = []
            this.setState({planId:res.id})
            this.props.currentPlan.shapesArray.forEach(shape => {
                var geoPoint = []
                shape.coordsArray.forEach(coord=>{
                    var point = new firebase.firestore.GeoPoint(coord.lat,coord.lng)
                    geoPoint.push(point)
                })
                var pro = null
                if(shape.uid === ''){
                    pro = firebase.firestore().collection('shapes').add({
                        plan:res.id,
                        points:geoPoint,
                        created_date:new Date(),
                        updated_date:new Date(),
                        type:shape.type,
                        name:shape.name,
                        uid:firebase.auth().currentUser.uid,
                        description:shape.description
                    })
                }else {
                    pro = firebase.firestore().collection('shapes').doc(shape.uid).update({
                        plan:res.id,
                        points:geoPoint,
                        created_date:new Date(),
                        updated_date:new Date(),
                        type:shape.type,
                        uid:firebase.auth().currentUser.uid,
                        name:shape.name,
                        description:shape.description
                    })
                }
                promise.push(pro)
            })
            return Promise.all(promise)
        })
        .then((docs)=>{
            var shapes = []
            docs.forEach(doc=>{
                shapes.push(doc.id)
            })
            return firebase.firestore().collection('plans').doc(this.state.planId).update({
                shapes:shapes
            })
        })
        .then(()=>{
            this.handleClose()
            setEdited(false)
            setSaved(false)
            setCurrentDroneLayer(null)
            getPlan(this.state.planId)
            window.history.pushState("","","/plan/"+this.state.planId)
        })
    }

    updateToFirebase(){
        const { name, description, address, deed } = this.state
        const { getPlan, setSaved, currentPlan, deleteShapes, setCurrentDroneLayer, setEdited, setSelectedShape ,setLoaded} = this.props

        var droneIdArray = []
        var layerSetting = []
        if(currentPlan.droneLayersArray !== []){
            currentPlan.droneLayersArray.forEach(layer=>{
                droneIdArray.push(layer.uid)
                layerSetting.push({is_hidden:false})
            })
        }
        var midpoint = null
        if( currentPlan.markerCoord !== null && currentPlan.markerCoord !== undefined && currentPlan.markerCoord !== '' ){
            midpoint = new firebase.firestore.GeoPoint(currentPlan.markerCoord.lat,currentPlan.markerCoord.lng)
        }

        firebase.firestore().collection('plans').doc(currentPlan.uid).update({
            address:address,
            deed:deed,
            description:description,
            name:name,
            midpoint:midpoint,
            layers:droneIdArray,
            layers_settings:layerSetting,
            uid:firebase.auth().currentUser.uid,
            created_date:new Date(),
            updated_date:new Date()
        })
        .then(()=>{
            var promise = []
            this.setState({planId:currentPlan.uid})
            this.props.currentPlan.shapesArray.forEach(shape => {
                var geoPoint = []
                var pro = null
                shape.coordsArray.forEach(coord=>{
                    var point = new firebase.firestore.GeoPoint(coord.lat,coord.lng)
                    geoPoint.push(point)
                })
                if(shape.uid === ''){
                    pro = firebase.firestore().collection('shapes').add({
                        plan:currentPlan.uid,
                        points:geoPoint,
                        created_date:new Date(),
                        updated_date:new Date(),
                        type:shape.type,
                        name:shape.name,
                        uid:firebase.auth().currentUser.uid,
                        description:shape.description
                    })
                } else {
                    pro = firebase.firestore().collection('shapes').doc(shape.uid).update({
                        plan:currentPlan.uid,
                        points:geoPoint,
                        created_date:new Date(),
                        updated_date:new Date(),
                        type:shape.type,
                        name:shape.name,
                        uid:firebase.auth().currentUser.uid,
                        description:shape.description
                    })
                }
                
                promise.push(pro)
            })
            return Promise.all(promise)
        })
        .then((docs)=>{
            var shapes = []
            var objs = currentPlan.shapesArray.filter(obj=>{
                return obj.uid !== ''
            })
            objs.forEach(obj=>{
                shapes.push(obj.uid)
            })
            docs.forEach(doc=>{
                if(doc !== undefined) shapes.push(doc.id)
            })
            return firebase.firestore().collection('plans').doc(currentPlan.uid).update({
                shapes:shapes
            })
        })
        .then(()=>{
            var promise = []
            deleteShapes.forEach(shape=>{
                var pro = firebase.firestore().collection('shapes').doc(shape.uid).delete()
                promise.push(pro)
            })
            return Promise.all(promise)
        })
        .then(()=>{
            this.handleClose()
            setLoaded(false)
            setEdited(false)
            setSaved(false)
            setSelectedShape(null)
            setCurrentDroneLayer(null)
            getPlan(this.state.planId)
            window.history.pushState("","","/plan/"+this.state.planId)
        })
    }

    render(){
        const {name, description, address, deed} = this.state
        const {currentPlan} = this.props
        return(
            <div className="MapsMenu">
            <div>
                <div className="UserMenu">
                    <div className="box">
                        <div className="ListHeader">
                            <span onClick={this.handleClose} className="CloseMenu"><i className="fas fa-times"></i></span>
                        </div>
                        <div>
                        <form onSubmit={this.handleSubmit}>
                            <div className="field">
                                <label className="label">ชื่อแปลง</label>
                                <div className="control">
                                    <input className="input is-rounded" type="text" onChange={this.handleChange} name='name' value={name} placeholder={currentPlan.name}></input>
                                </div>
                            </div>
                            <div className="field">
                                <label className="label">รายละเอียด</label>
                                <div className="control">
                                    <input className="input is-rounded" type="text" onChange={this.handleChange} name='description' value={description} placeholder={currentPlan._description}></input>
                                </div>
                            </div>
                            <div className="field">
                                <label className="label">ที่อยู่</label>
                                <div className="control">
                                    <input className="input is-rounded" type="text" onChange={this.handleChange} name="address" value={address} placeholder={currentPlan.address}></input>
                                </div>
                            </div>
                            <div className="field">
                                <label className="label">เลขโฉนด</label>
                                <div className="control">
                                    <input className="input is-rounded" type="text" onChange={this.handleChange} name="deed" value={deed} placeholder={currentPlan.deed}></input>
                                </div>
                            </div>
                            <div className="divBtn">
                                    <input className="button is-primary is-max-width" type="submit" value="บันทึก" />
                            </div>
                        </form>
                        </div>
                    </div>
                </div>
            </div>

            </div>
        )
    }
}

export default PlanDetailsSave


// WEBPACK FOOTER //
// ./src/PageMaps/_PlanDetailsSave.js